/// <amd-module name="Repos/Views/PullRequest/Components/ActivityFeed/ActivityCards/PREventCard" />
import * as React from "react";
import * as Resources from "Repos/Views/PullRequest/Resources";
import * as Utils_String from "VSS/Core/Util/String";
import { FormatComponent } from "VSS/Platform/Components/Format";
import { Components } from "VSS/Platform/Layout";
import { IBasicIdentityRef } from "VSSUI/Persona";
import { getIdentity, getIdentityComponent, getPropertyValue } from "../Utils/ActivityFeedUtils";
import { ActivityCardSubtle, IActivityCardSharedProps } from "./ActivityCardSubtle";
import { ActivityShimmer } from "./ActivityShimmer";

export const PREventCard: React.FunctionComponent<IActivityCardSharedProps> = props => {
    const { isShim } = props;

    let bypassReason = "";
    let format = "";
    let identity: IBasicIdentityRef | undefined;

    if (!isShim) {
        const identityId = getPropertyValue(props.thread, "CodeReviewStatusUpdatedByIdentity");
        identity = getIdentity(props.thread, identityId);

        if (!identity) {
            return null;
        }

        const status = getPropertyValue(props.thread, "CodeReviewStatus");

        if (Utils_String.localeIgnoreCaseComparer(status, "Create") === 0) {
            format = Resources.ActivityFeedCreatedBy;
        } else if (Utils_String.localeIgnoreCaseComparer(status, "Active") === 0) {
            format = Resources.ActivityFeedReactivatedBy;
        } else if (Utils_String.localeIgnoreCaseComparer(status, "Abandoned") === 0) {
            format = Resources.ActivityFeedAbandonedBy;
        } else {
            const bypassPolicy = Utils_String.localeIgnoreCaseComparer(getPropertyValue(props.thread, "BypassPolicy"), "True") === 0;
            bypassReason = getPropertyValue(props.thread, "BypassReason");
            if (bypassPolicy) {
                format = Resources.ActivityFeedCompletedAndBypassedBy;
            } else {
                format = Resources.ActivityFeedCompletedBy;
            }
        }
    }

    return (
        <ActivityCardSubtle createDate={props.thread.publishedDate}>
            {isShim ? (
                <ActivityShimmer />
            ) : (
                <div className="flex-column">
                    <FormatComponent className="flex-row flex-center flex-wrap" format={format}>
                        {getIdentityComponent(identity!, "activity-card-first-image")}
                    </FormatComponent>
                    {bypassReason && (
                        <div className="flex-row flex-center flex-wrap">{Utils_String.format(Resources.ActivityFeedBypassReason, bypassReason)}</div>
                    )}
                </div>
            )}
        </ActivityCardSubtle>
    );
};

Components.add("ms.vss-code-web.pr-event-activity-card", PREventCard);
